module.exports = __webpack_public_path__ + "static/media/profile-default.b84a84b6.svg";